<template>
  <v-toolbar app style="padding-bottom:1rem; padding-top:1rem;">
    <v-toolbar-title class="headline text-uppercase">
      <div>
        <v-img class="logo-header" :src="images.logo" />
        <span class="font-weight-light logo-text">--CarterNoir--</span>
      </div>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn flat href="tel:+61438088255">
      <v-img
        class="mr-2 phone-icon"
        :src="require('./../../assets/icons/header-icon-mobile.png')"
      />
      <span class="mr-2" style="color:#ffffff;" @click="phoneHeaderClicked">(+61) 438 088 225<br />Dudley Maudlin</span>
    </v-btn>
  </v-toolbar>
</template>

<style lang="scss" scoped>
.logo-header {
  max-height: 15px;
  padding: 1.33rem 0;
  margin: 1rem 0 0 0;
}
.logo-text {
  opacity: 0;
}
.phone-icon {
  max-height: 5px;
}
</style>

<script>
export default {
  name: "Header",
  data() {
    return {
      images: {
        logo: require("../../assets/dark-mode/logo.png")
      }
    };
  },
  methods: {
    phoneHeaderClicked() {
      analytics.track("phoneHeaderClicked", {
        event: "phoneHeaderClicked",
        label: "phoneHeaderClicked"
      })
    }
  }
};
</script>
